export default "__VITE_ASSET__ShResEHq__"